import styled from 'styled-components';
import theme from '../utils/theme';

const Contact = styled.div`
  background: ${theme.blanco};
  width: 100%;
  height: auto;
`;

const Title = styled.h1`
    font-size: 36px;
    font-weight: 700;
    text-align: center;
    font-family: 'Raleway', sans-serif;
    color: ${theme.letra} !important;
    margin: 0 !important;

    @media screen and (max-width: 1024px) {
        font-size: 28px;
    }
`;

const Description = styled.h2`
    font-weight: 400;
    font-family: 'Raleway', sans-serif;
    font-size: 18px;
    line-height: 1.6;
    width: 50vw;
    max-width: 650px;
    margin: 16px auto 0 auto !important;
    text-align: center;
    color: ${theme.letraClara};

    @media screen and (max-width: 1024px) {
        width: 90%;
        font-size: 16px;
    }
`;

const DivForm = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 48px !important;
`;

const Formulario = styled.form`
    width: 100%;
    max-width: 680px;
    background: ${theme.blanco};
    padding: 40px !important;
    border-radius: 16px;
    border: 1px solid ${theme.grisFuerte};
    box-shadow: 0 10px 25px -5px rgba(15, 23, 42, 0.05);

    @media screen and (max-width: 800px) {
        width: 90%;
        padding: 24px !important;
    }
`;

const Ul = styled.ul`
    padding: 0 !important;
    margin: 0 !important;
    list-style: none;
    display: flex;
    flex-direction: column;
    gap: 20px;
`;

const FormRow = styled.div`
    display: flex;
    gap: 20px;
    width: 100%;

    @media screen and (max-width: 640px) {
        flex-direction: column;
        gap: 20px;
    }
`;

const FormGroup = styled.li`
    list-style: none;
    display: flex;
    flex-direction: column;
    width: 100%;

    label {
        font-size: 14px;
        line-height: 20px;
        color: ${theme.letra};
        font-family: 'Inter', sans-serif;
        font-weight: 600;
        margin-bottom: 8px !important;
    }
`;

const InputText = styled.input`
    width: 100%;
    height: 44px;
    font-size: 15px;
    font-family: 'Inter', sans-serif;
    border: 1px solid ${theme.inputBorder} !important;
    border-radius: 8px;
    padding: 0 14px !important;
    background: ${theme.inputBg};
    color: ${theme.letra};
    outline: none;
    box-sizing: border-box;
    transition: all 200ms ease-in-out;

    &::placeholder {
        color: ${theme.letraClara};
    }

    &:focus {
        background: ${theme.blanco};
        border-color: ${theme.azulFuerte} !important;
        box-shadow: 0 0 0 4px ${theme.azulFocusRing};
    }
`;

const Message = styled.textarea`
    width: 100%;
    height: 120px;
    font-size: 15px;
    font-family: 'Inter', sans-serif;
    border: 1px solid ${theme.inputBorder} !important;
    border-radius: 8px;
    padding: 12px 14px !important;
    background: ${theme.inputBg};
    color: ${theme.letra};
    outline: none;
    box-sizing: border-box;
    resize: vertical;
    transition: all 200ms ease-in-out;

    &::placeholder {
        color: ${theme.letraClara};
    }

    &:focus {
        background: ${theme.blanco};
        border-color: ${theme.azulFuerte} !important;
        box-shadow: 0 0 0 4px ${theme.azulFocusRing};
    }
`;

const SpanError = styled.span`
    color: ${theme.rojo};
    font-size: 13px;
    font-family: 'Inter', sans-serif;
    margin-top: 6px !important;
    display: block;

    p {
        margin: 0 !important;
    }
`;

const LiSubmit = styled.div`
    display: flex;
    justify-content: flex-end;
    margin-top: 10px !important;

    @media screen and (max-width: 640px) {
        justify-content: center;
    }
`;

const Submit = styled.button`
    width: 100%;
    height: 46px;
    font-size: 15px;
    font-weight: 600;
    font-family: 'Inter', sans-serif;
    border: none;
    border-radius: 8px;
    background: ${theme.azulFuerte};
    color: ${theme.letraBlanca};
    outline: none;
    cursor: pointer;
    transition: all 200ms ease-in-out;

    &:hover {
        background: ${theme.azulHover};
        transform: translateY(-1px);
    }

    &:active {
        transform: translateY(0);
    }
`;

export {
  Contact,
  Title,
  Description,
  DivForm,
  Formulario,
  Ul,
  FormRow,
  FormGroup,
  InputText,
  Message,
  SpanError,
  LiSubmit,
  Submit
};